import { gql } from '@apollo/client';

export const getSignedUrl = gql`
  query getSignedUrlForIdentityValidationDocument(
    $identityValidationId: String!
    $document: IdentityValidationDocumentName!
  ) {
    getSignedUrlForIdentityValidationDocument(identityValidationId: $identityValidationId, document: $document) {
      value
    }
  }
`;
